import React from 'react';
import HomeAboutImg from '../../assets/images/about/about.jpg';
import '../../assets/css/HomeAbout.css'; // Create this CSS file

const HomeAbout = () => {
    return (
        <div className="about-area gray-bg-2 pt-200 pb-160">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-xl-6 col-lg-6 col-md-6">
                        <div className="about-img-wrapper">
                            <img 
                                src={HomeAboutImg} 
                                alt="Bright Sun Cleaning & Gardening team working" 
                                className="about-image"
                            />
                            <div className="about-award">
                                <h3>Trusted Since 2020!</h3>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6">
                        <div className="about-text-wrapper pt-30">
                            <div className="section-title mb-40">
                                <span className="section-subtitle">We are Committed to Cleaning & Landscape Services</span>
                                <h2>Creating Pristine, Thriving Spaces for Homes & Businesses</h2>
                                <p className="about-description">
                                    At Bright Sun Cleaning & Gardening Services, we combine expert cleaning with sustainable landscape solutions. Our team transforms both indoor and outdoor environments using eco-friendly practices and professional techniques.
                                </p>
                            </div>
                            <a href="/contact" className="l-btn">Book Appointment</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeAbout;